import React from 'react';
import { useMutation } from '@apollo/client';

import { ACTION_CODES } from 'constants/errors';
import AgentPortalError from 'errors/AgentPortalError';
import { getPaymentsURL, getRefundMethodsURL } from 'utils/urls';
import formatReason from 'utils/formatReason';

import { CONFIRM_BOOKING, REVERT_CHANGE, REFUND_BOOKING_FEES } from './graphql';

import BookingFees from './BookingFees';

const BookingFeesContainer = ({
  intl,
  bookingFees,
  bookingReference,
  toBeRefunded,
  history,
  user,
  bookingStatus,
  disabled = false,
  disabledTooltipMessageId = ''
}) => {
  const membershipNumber = new URLSearchParams(history?.location?.search).get('membershipNumber');

  const [revertChange, revertChangeState] = useMutation(REVERT_CHANGE, {
    variables: { bookingReference },
    refetchQueries: ['booking'],
    awaitRefetchQueries: true
  });

  const [confirmBooking, confirmBookingState] = useMutation(CONFIRM_BOOKING, {
    variables: { bookingReference },
    onCompleted: () => history.push(getRefundMethodsURL(bookingReference, toBeRefunded.currency, membershipNumber, true)),
    refetchQueries: ['booking'],
    awaitRefetchQueries: true
  });

  const [refundBookingFees, refundBookingFeesState] = useMutation(REFUND_BOOKING_FEES, {
    refetchQueries: ['booking'],
    awaitRefetchQueries: true
  });

  const state = [revertChangeState, confirmBookingState, refundBookingFeesState];
  const error = state.map((item) => item.error).find(Boolean);

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: getPaymentsURL(bookingReference, membershipNumber)
    });
  }

  const handleRefund = async (data) => {
    const { itemRefs, reasonCode, additionalExplanation, label } = data;

    await refundBookingFees({
      variables: {
        itemRefs,
        overrideReason: formatReason(reasonCode, additionalExplanation, label),
        bookingReference
      }
    });
  };

  return (
    <BookingFees
      user={user}
      intl={intl}
      onRefund={handleRefund}
      onCancel={revertChange}
      onConfirm={confirmBooking}
      isRefunding={refundBookingFeesState.loading}
      isCancelling={revertChangeState.loading}
      isConfirming={confirmBookingState.loading}
      bookingFees={bookingFees}
      toBeRefunded={toBeRefunded}
      bookingStatus={bookingStatus}
      disabled={disabled}
      disabledTooltipMessageId={disabledTooltipMessageId}
    />
  );
};

BookingFeesContainer.propTypes = {
  ...BookingFees.propTypes
};

export default BookingFeesContainer;
